import React, { forwardRef } from 'react';
import ButtonBase from "../ButtonBase";

const ToggleButton = forwardRef(function ToggleButton(props, ref) {
  const {
    children,
    label,
    className,
    disabled = false,
    onChange,
    onClick,
    selected,
    value,
    ...other
  } = props;

  const handleClick = (event) => {
    if (onClick) {
      onClick(event, value);
      if (event.isDefaultPrevented()) {
        return;
      }
    }

    if (onChange) {
      onChange(event, value);
    }
  };

  return (
    <ButtonBase
      className={className}
      disabled={disabled}
      ref={ref}
      onClick={handleClick}
      onChange={onChange}
      value={value}
      aria-pressed={selected}
      {...other}
    >
      {
        label
          ? <span className={label}>{children}</span>
          : children
      }
    </ButtonBase>
  );
});

export default ToggleButton;
